import styled from 'styled-components';

export const TooltipContainer = styled.div`
  padding: 5px;
  overflow: auto;
`;
